import React from 'react'
import './styles.css'
import gif from './assets/loading.gif'
function Loader({className =''}) {
  return <img src={gif} className={`h-[150px] w-auto ${className}`} alt="Loading..."/>
}

export default Loader
